// components/SemesterSelector.js
import React from 'react';
import moment from 'moment';

const SemesterSelector = ({ show, semesterOptions, onSelect }) => {
  if (!show || !semesterOptions || semesterOptions.length === 0) return null;

  return (
    <div className="text-center py-16">
      <div className="max-w-2xl mx-auto">
        <div className="w-20 h-20 bg-gradient-to-r from-blue-100 to-purple-100 rounded-3xl flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-4">Select Semester</h3>
        <p className="text-gray-600 mb-12 text-lg">
          Choose which semester calendar you want to view and manage
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto">
          {semesterOptions.map((semester) => (
            <button
              key={semester.type}
              onClick={() => onSelect(semester.type)}
              className={`p-8 ${
                semester.type === 'odd'
                  ? 'bg-gradient-to-br from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 border-2 border-blue-200'
                  : 'bg-gradient-to-br from-purple-50 to-purple-100 hover:from-purple-100 hover:to-purple-200 border-2 border-purple-200'
              } rounded-2xl transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl group`}
            >
              <div className={`w-16 h-16 ${
                semester.type === 'odd' ? 'bg-blue-500' : 'bg-purple-500'
              } rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform`}>
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">
                {semester.type === 'odd' ? 'Odd Semester' : 'Even Semester'}
              </h4>
              <p className="text-gray-600">
                {semester.startDate && semester.endDate
                  ? `${moment(semester.startDate).format('MMM DD, YYYY')} - ${moment(semester.endDate).format('MMM DD, YYYY')}`
                  : 'Dates not configured'}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SemesterSelector;